import PoweredByService from '../services/poweredBy.service';
import defaultTheme from '@/plugins/theme';

const poweredBy = {
  namespaced: true,

  state: {
    th: localStorage.getItem('mbth'),
    theme: null,
  },
  mutations: {
    UPDATE_TH(state, th) {
      state.th = th;
      localStorage.setItem('mbth', th);
    },
    CONFIG_THEME(state, theme) {
      state.theme = theme;
    },
  },
  actions: {
    all() {
      return PoweredByService.all();
    },
    one(_, id) {
      return PoweredByService.one(id);
    },
    getTheme({ commit, state }, th) {
      commit('UPDATE_TH', th);

      return PoweredByService.getTheme(th).then((theme) => {
        commit('CONFIG_THEME', theme);
        return theme;
      });
    },
    create(_, theme) {
      return PoweredByService.create(theme);
    },
    update(_, theme) {
      return PoweredByService.update(theme);
    },
    remove(_, id) {
      return PoweredByService.remove(id);
    },
    saveImage(_, { id, base64Image, type }) {
      return PoweredByService.saveImage(id, base64Image, type);
    },
    configTheme({ commit, state }, theme) {
      if (theme) {
        commit('CONFIG_THEME', theme);
      }
    },
  },
  getters: {
    th(state) {
      return state.th;
    },
    theme(state) {
      return state.theme;
    },
  },
};

export default poweredBy;
